import React from 'react';
import Icon from '../common/Icon';

const DashboardNavItem = ({ icon, label, tabName, activeTab, setActiveTab }) => (
    <li className="mb-2">
        <a href="#" onClick={() => setActiveTab(tabName)} className={`flex items-center p-3 rounded-lg transition duration-200 ${activeTab === tabName ? 'bg-[#B67BF4]/20 text-[#B67BF4]' : 'text-gray-600 hover:bg-[#7B34BB]/10'}`}>
        <Icon path={icon} className="w-6 h-6 mr-3" />
            <span className="font-medium">{label}</span>
        </a>
    </li>
);

export default DashboardNavItem;

